export default __webpack_public_path__ + "static/media/GarbageDelteRed.2d48df5c.svg";